module.exports = __webpack_public_path__ + "media/newstyle/images/icon-add-f50e78e0f600a60c7e99b3f6873c5c02.svg";